package diana.soleil.design.iraniancanadienbazzar.feature.feed

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.verticalScroll
import androidx.compose.ui.draw.clip
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.lazy.LazyColumn
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_more_actions_a11y
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppMenuItem
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppOverflowMenu
import org.jetbrains.compose.resources.stringArrayResource
import kotlinx.datetime.toLocalDateTime
import kotlinx.datetime.TimeZone
import diana.soleil.design.iraniancanadienbazzar.core.model.Event
import diana.soleil.design.iraniancanadienbazzar.core.model.Deal
import diana.soleil.design.iraniancanadienbazzar.core.model.Business
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.SectionHeader
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AccentBadge
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.foundation.layout.RowScope
import androidx.compose.foundation.rememberScrollState
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import diana.soleil.design.iraniancanadienbazzar.core.common.ShareService
import diana.soleil.design.iraniancanadienbazzar.core.data.CityController
import diana.soleil.design.iraniancanadienbazzar.core.data.ShareConfig
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppBottomSheet
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppButtonVariant
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppConfirmDialog
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppCard
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.PersonAvatar
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppChip
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.IconBadge
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIcon
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppTextField
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.BusinessCover
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.EmptyState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ErrorState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.FeedPostSkeleton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.appContentWidth
import diana.soleil.design.iraniancanadienbazzar.core.model.Post
import diana.soleil.design.iraniancanadienbazzar.core.model.PostType
import diana.soleil.design.iraniancanadienbazzar.core.model.formatCount
import diana.soleil.design.iraniancanadienbazzar.core.model.cityLabel
import diana.soleil.design.iraniancanadienbazzar.core.model.localizeDigits
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.Res
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_composer_add_photo
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_composer_photo_attached
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_composer_placeholder
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_composer_publish
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_like_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_load_older
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_save_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_share_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_unlike_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_unsave_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_post_photo_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_time_days_ago
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_time_hours_ago
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_time_just_now
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_time_minutes_ago
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_time_weeks_ago
import kotlin.time.Clock
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_action_failed
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_empty_desc
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_empty_title
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_error
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_filter_all
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_sort_most_liked
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_sort_newest
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_sort_photos
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_post_failed
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_retry
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_filter_events
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_filter_deals
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_filter_new
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_kicker_event
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_kicker_deal
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_kicker_new
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_event_going
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_event_details
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_deal_ends_today
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_deal_ends_days
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_deal_view
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_deal_badge
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_new_in_city
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_new_view
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_follow
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_following
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_trending_title
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_suggested_title
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_card_image_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_community_empty_title
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_community_empty_desc
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_months
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_event_date_format
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_event_am
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_event_pm
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_title
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_type_general
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_type_question
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_type_recommendation
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_comments
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_recommend_business
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_recommend_title
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_recommend_search
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_recommend_attached
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_comment_recommended_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_report_action
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_report_done
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_report_failed
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_report_reason_harassment
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_report_reason_misinformation
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_report_reason_offensive
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_report_reason_spam
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_report_sent
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_report_submit
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_report_title
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIconButton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ReportReason
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ReportSheet
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ReportStatus
import org.jetbrains.compose.resources.pluralStringResource
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.koinInject
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_comment_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_comment_empty
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_comment_delete_failed
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_comment_failed
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_comment_placeholder
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_comment_report_action
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_comment_report_sent
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_comment_report_title
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_comment_send
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_comments_title
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_delete_cancel
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_delete_comment_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_delete_comment_message
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_delete_comment_title
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_delete_confirm
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_delete_post_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_delete_post_message
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_delete_post_title
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_block_confirm
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_block_message
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_block_title
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_block_user_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_edit_post_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_edit_post_save
import diana.soleil.design.iraniancanadienbazzar.feature.feed.resources.feed_edit_post_title
import org.koin.compose.viewmodel.koinViewModel
import org.koin.core.parameter.parametersOf

/** Stateful feed entry (FEED tab). Guests read freely; publishing bounces them to sign-in. */
@Composable
fun FeedRoute(
    onRequireSignIn: () -> Unit,
    modifier: Modifier = Modifier,
    onOpenBusiness: (String) -> Unit = {},
    onOpenEvent: (String) -> Unit = {},
    viewModel: FeedViewModel = koinViewModel(),
) {
    // The shell's "Ask the mahaleh" action lands here: open the composer pre-set to Question.
    val askRequested by FeedDeepLinks.pendingAsk.collectAsStateWithLifecycle()
    val state by viewModel.state.collectAsStateWithLifecycle()
    val cityController = koinInject<CityController>()
    val activeMetroId by cityController.activeMetroId.collectAsStateWithLifecycle()
    // Same share plumbing as business/marketplace detail: platform ShareService + RC-driven base URL.
    val shareService = koinInject<ShareService>()
    val shareConfig = koinInject<ShareConfig>()
    var reportPostId by remember { mutableStateOf<String?>(null) }
    var commentsPostId by remember { mutableStateOf<String?>(null) }
    var deletePostId by remember { mutableStateOf<String?>(null) }
    var editPost by remember { mutableStateOf<Post?>(null) }
    var blockPost by remember { mutableStateOf<Post?>(null) }
    // A tapped comment notification opens this post's comments sheet (see FeedDeepLinks).
    val pendingCommentsPostId by FeedDeepLinks.pendingCommentsPostId.collectAsStateWithLifecycle()
    LaunchedEffect(pendingCommentsPostId) {
        pendingCommentsPostId?.let {
            commentsPostId = it
            FeedDeepLinks.consume()
        }
    }
    LaunchedEffect(state.signInRequired) {
        if (state.signInRequired) {
            viewModel.consumeGate()
            onRequireSignIn()
        }
    }
    LaunchedEffect(state.reportStatus) {
        if (state.reportStatus == PostReportStatus.SignInRequired) {
            reportPostId = null
            viewModel.resetReport()
            onRequireSignIn()
        }
    }
    FeedScreen(
        state = state,
        onFilter = viewModel::setFilter,
        onSort = viewModel::setSort,
        onOpenEvent = onOpenEvent,
        onOpenBusiness = onOpenBusiness,
        onFollow = viewModel::toggleFollow,
        onRetry = viewModel::retry,
        onPublish = { type, text -> viewModel.publish(type, text, activeMetroId) },
        onAttachPhoto = viewModel::attachPhoto,
        onRemovePhoto = viewModel::removePhoto,
        askRequested = askRequested,
        onAskConsumed = { FeedDeepLinks.consumeAsk() },
        onLoadOlder = viewModel::loadOlder,
        onToggleLike = viewModel::toggleLike,
        onToggleSave = viewModel::toggleSave,
        onReport = { postId -> reportPostId = postId },
        onOpenComments = { postId -> commentsPostId = postId },
        onDeletePost = { postId -> deletePostId = postId },
        onEditPost = { post -> editPost = post },
        onBlockUser = { post -> blockPost = post },
        onSharePost = { post ->
            val snippet = post.text.trim().let { if (it.length > 280) it.take(279) + "…" else it }
            shareService.share(
                listOf(snippet, shareConfig.postLink(post.id))
                    .filter { it.isNotBlank() }
                    .joinToString("\n"),
            )
        },
        modifier = modifier,
    )

    blockPost?.let { post ->
        AppConfirmDialog(
            title = stringResource(Res.string.feed_block_title, post.authorName),
            message = stringResource(Res.string.feed_block_message),
            confirmLabel = stringResource(Res.string.feed_block_confirm),
            cancelLabel = stringResource(Res.string.feed_delete_cancel),
            destructive = true,
            onConfirm = {
                viewModel.blockUser(post.authorUid, post.authorName)
                blockPost = null
            },
            onDismiss = { blockPost = null },
        )
    }

    editPost?.let { post ->
        EditPostSheet(
            post = post,
            onDismiss = { editPost = null },
            onSave = { type, text ->
                viewModel.updatePost(post.id, type, text)
                editPost = null
            },
        )
    }

    commentsPostId?.let { postId ->
        CommentsSheet(
            postId = postId,
            onOpenBusiness = onOpenBusiness,
            onRequireSignIn = onRequireSignIn,
            onDismiss = { commentsPostId = null },
        )
    }

    deletePostId?.let { postId ->
        AppConfirmDialog(
            title = stringResource(Res.string.feed_delete_post_title),
            message = stringResource(Res.string.feed_delete_post_message),
            confirmLabel = stringResource(Res.string.feed_delete_confirm),
            cancelLabel = stringResource(Res.string.feed_delete_cancel),
            destructive = true,
            onConfirm = {
                viewModel.deletePost(postId)
                deletePostId = null
            },
            onDismiss = { deletePostId = null },
        )
    }

    if (reportPostId != null) {
        val targetPostId = reportPostId!!
        ReportSheet(
            title = stringResource(Res.string.feed_report_title),
            reasons = listOf(
                ReportReason(stringResource(Res.string.feed_report_reason_offensive), "offensive_content"),
                ReportReason(stringResource(Res.string.feed_report_reason_harassment), "harassment"),
                ReportReason(stringResource(Res.string.feed_report_reason_spam), "spam"),
                ReportReason(stringResource(Res.string.feed_report_reason_misinformation), "misinformation"),
            ),
            status = when (state.reportStatus) {
                PostReportStatus.Sending -> ReportStatus.Sending
                PostReportStatus.Sent -> ReportStatus.Sent
                PostReportStatus.Failed -> ReportStatus.Failed
                PostReportStatus.Idle, PostReportStatus.SignInRequired -> ReportStatus.Idle
            },
            sentText = stringResource(Res.string.feed_report_sent),
            failedText = stringResource(Res.string.feed_report_failed),
            submitText = stringResource(Res.string.feed_report_submit),
            doneText = stringResource(Res.string.feed_report_done),
            onSubmit = { reason -> viewModel.report(targetPostId, reason) },
            onDismiss = {
                reportPostId = null
                viewModel.resetReport()
            },
        )
    }
}

/**
 * Community feed (Stitch `c8b1f8fb`): type filter chips, inline composer (with optional photo
 * attach), post cards (initial-avatar author row, type chip, text, one full-width photo, comment
 * count) with like/comment/share/save actions. Deliberate v1 deviation (in code, no fake
 * affordances): no follow buttons yet — they arrive with their real backend. Tokens + string
 * resources only.
 */
@Composable
fun FeedScreen(
    state: FeedUiState,
    onFilter: (FeedFilter) -> Unit,
    onPublish: (PostType, String) -> Unit,
    onAttachPhoto: () -> Unit,
    onRemovePhoto: () -> Unit,
    onLoadOlder: () -> Unit,
    onToggleLike: (String, Boolean) -> Unit,
    onToggleSave: (String, Boolean) -> Unit,
    onReport: (String) -> Unit,
    onOpenComments: (String) -> Unit,
    onDeletePost: (String) -> Unit,
    onEditPost: (Post) -> Unit,
    onBlockUser: (Post) -> Unit,
    onSharePost: (Post) -> Unit,
    modifier: Modifier = Modifier,
    onSort: (FeedSort) -> Unit = {},
    onRetry: () -> Unit = {},
    /** One-shot "ask the mahaleh" trigger from the shell: expand the composer as a Question. */
    askRequested: Boolean = false,
    onAskConsumed: () -> Unit = {},
    /** Community cards: an event card opens the event, deal/new-listing cards open the business. */
    onOpenEvent: (String) -> Unit = {},
    onOpenBusiness: (String) -> Unit = {},
    /** Follow/unfollow from a new-listing card or the Suggested rail (businessId, currently following). */
    onFollow: (String, Boolean) -> Unit = { _, _ -> },
) {
    if (state.error) {
        ErrorState(
            message = stringResource(Res.string.feed_error),
            onRetry = onRetry,
            retryLabel = stringResource(Res.string.feed_retry),
            modifier = modifier,
        )
        return
    }
    Box(modifier = modifier.fillMaxSize().background(AppTheme.colors.background)) {
        LazyColumn(
            modifier = Modifier.appContentWidth(AppTheme.sizes.contentMaxWidth).fillMaxHeight().statusBarsPadding(),
            contentPadding = PaddingValues(
                start = AppTheme.spacing.lg,
                end = AppTheme.spacing.lg,
                top = AppTheme.spacing.md,
                bottom = AppTheme.spacing.xl,
            ),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
        ) {
            item {
                Text(
                    text = stringResource(Res.string.feed_title),
                    style = AppTheme.typography.headlineLg,
                    color = AppTheme.colors.onSurface,
                )
            }
            item {
                Composer(
                    posting = state.posting,
                    failed = state.postFailed,
                    signInRequired = state.signInRequired,
                    photoAttached = state.photoAttached,
                    onAttachPhoto = onAttachPhoto,
                    onRemovePhoto = onRemovePhoto,
                    onPublish = onPublish,
                    askRequested = askRequested,
                    onAskConsumed = onAskConsumed,
                )
            }
            if (state.actionFailed) {
                // Deleting/editing a post failed — inline error above the filter chips.
                item {
                    Text(
                        text = stringResource(Res.string.feed_action_failed),
                        style = AppTheme.typography.bodySm,
                        color = AppTheme.colors.onErrorContainer,
                    )
                }
            }
            item {
                Row(
                    modifier = Modifier.horizontalScroll(rememberScrollState()),
                    horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
                ) {
                    // Stitch c8b1f8fb chip row: All · Events · Deals · New, then the post kinds.
                    FeedFilter.entries.forEach { lens ->
                        AppChip(
                            label = stringResource(lens.label()),
                            selected = state.filter == lens,
                            onClick = { onFilter(lens) },
                        )
                    }
                }
            }
            if (!state.filter.isCommunity) item {
                // Sort row: chronological (default), most liked, or photo posts first.
                Row(
                    modifier = Modifier.horizontalScroll(rememberScrollState()),
                    horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
                ) {
                    AppChip(
                        label = stringResource(Res.string.feed_sort_newest),
                        selected = state.sort == FeedSort.Newest,
                        onClick = { onSort(FeedSort.Newest) },
                    )
                    AppChip(
                        label = stringResource(Res.string.feed_sort_most_liked),
                        selected = state.sort == FeedSort.MostLiked,
                        leadingIcon = "favorite",
                        onClick = { onSort(FeedSort.MostLiked) },
                    )
                    AppChip(
                        label = stringResource(Res.string.feed_sort_photos),
                        selected = state.sort == FeedSort.Photos,
                        leadingIcon = "photo_camera",
                        onClick = { onSort(FeedSort.Photos) },
                    )
                }
            }

            if (state.loading) {
                // Shimmer skeletons shaped like posts — no spinner-on-blank while the feed loads.
                items(3) { FeedPostSkeleton() }
                return@LazyColumn
            }
            val entries = state.entries
            if (entries.isEmpty()) {
                item {
                    if (state.filter.isCommunity) {
                        EmptyState(
                            title = stringResource(Res.string.feed_community_empty_title),
                            description = stringResource(Res.string.feed_community_empty_desc),
                        )
                    } else {
                        EmptyState(
                            title = stringResource(Res.string.feed_empty_title),
                            description = stringResource(Res.string.feed_empty_desc),
                        )
                    }
                }
            } else {
                items(count = entries.size, key = { entries[it].key }) { index ->
                    when (val entry = entries[index]) {
                        is FeedEntry.PostEntry -> {
                            val post = entry.post
                            PostCard(
                                post = post,
                                isMine = state.currentUid != null && post.authorUid == state.currentUid,
                                liked = post.id in state.likedPostIds,
                                saved = post.id in state.savedPostIds,
                                onToggleLike = { onToggleLike(post.id, post.id in state.likedPostIds) },
                                onToggleSave = { onToggleSave(post.id, post.id in state.savedPostIds) },
                                onReport = { onReport(post.id) },
                                onOpenComments = { onOpenComments(post.id) },
                                onDelete = { onDeletePost(post.id) },
                                onEdit = { onEditPost(post) },
                                onBlock = { onBlockUser(post) },
                                onShare = { onSharePost(post) },
                            )
                        }
                        is FeedEntry.EventEntry -> EventFeedCard(
                            event = entry.event,
                            goingCount = entry.goingCount,
                            onClick = { onOpenEvent(entry.event.id) },
                        )
                        is FeedEntry.DealEntry -> DealFeedCard(
                            deal = entry.deal,
                            business = entry.business,
                            onClick = { onOpenBusiness(entry.deal.businessId) },
                        )
                        is FeedEntry.BusinessEntry -> NewBusinessFeedCard(
                            business = entry.business,
                            following = entry.business.id in state.followingIds,
                            onClick = { onOpenBusiness(entry.business.id) },
                            onFollow = { onFollow(entry.business.id, entry.business.id in state.followingIds) },
                        )
                    }
                }
                if (state.hasMore && !state.filter.isCommunity) {
                    // Stitch c8b1f8fb: tonal "Load Older Posts" pill closes the list.
                    item {
                        Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
                            AppButton(
                                text = stringResource(Res.string.feed_load_older),
                                onClick = onLoadOlder,
                                variant = AppButtonVariant.Tonal,
                            )
                        }
                    }
                }
            }
            // Stitch c8b1f8fb closes the feed with "Trending near you" + "Suggested for you".
            if (state.filter == FeedFilter.All) {
                val trending = state.trending
                if (trending.isNotEmpty()) {
                    item(key = "trending_header") {
                        SectionHeader(
                            title = stringResource(Res.string.feed_trending_title),
                            modifier = Modifier.padding(top = AppTheme.spacing.md),
                        )
                    }
                    item(key = "trending") {
                        AppCard(modifier = Modifier.fillMaxWidth()) {
                            Column(modifier = Modifier.padding(vertical = AppTheme.spacing.sm)) {
                                trending.forEach { event ->
                                    TrendingRow(
                                        event = event,
                                        goingCount = state.goingCounts[event.id] ?: 0,
                                        onClick = { onOpenEvent(event.id) },
                                    )
                                }
                            }
                        }
                    }
                }
                val suggested = state.suggested
                if (suggested.isNotEmpty()) {
                    item(key = "suggested_header") {
                        SectionHeader(
                            title = stringResource(Res.string.feed_suggested_title),
                            modifier = Modifier.padding(top = AppTheme.spacing.md),
                        )
                    }
                    item(key = "suggested") {
                        AppCard(modifier = Modifier.fillMaxWidth()) {
                            Column(modifier = Modifier.padding(vertical = AppTheme.spacing.sm)) {
                                suggested.forEach { business ->
                                    SuggestedRow(
                                        business = business,
                                        following = business.id in state.followingIds,
                                        onClick = { onOpenBusiness(business.id) },
                                        onFollow = { onFollow(business.id, business.id in state.followingIds) },
                                    )
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

private fun PostType.label() = when (this) {
    PostType.General -> Res.string.feed_type_general
    PostType.Question -> Res.string.feed_type_question
    PostType.Recommendation -> Res.string.feed_type_recommendation
}

private fun FeedFilter.label() = when (this) {
    FeedFilter.All -> Res.string.feed_filter_all
    FeedFilter.Events -> Res.string.feed_filter_events
    FeedFilter.Deals -> Res.string.feed_filter_deals
    FeedFilter.New -> Res.string.feed_filter_new
    FeedFilter.Update -> Res.string.feed_type_general
    FeedFilter.Question -> Res.string.feed_type_question
    FeedFilter.Recommendation -> Res.string.feed_type_recommendation
}

/**
 * Shared frame for the community cards (Stitch c8b1f8fb business posts): avatar + name + kicker
 * badge + meta line, body copy, optional cover with an optional badge, then an action row. The
 * kicker/action copy is the caller's; this only fixes the geometry so the three kinds read as one
 * family alongside member posts.
 */
@Composable
private fun CommunityCard(
    title: String,
    meta: String,
    body: String,
    coverContentDescription: String,
    onClick: () -> Unit,
    avatar: @Composable () -> Unit,
    kicker: @Composable () -> Unit,
    coverUrl: String? = null,
    coverIcon: String = "storefront",
    coverBadge: String? = null,
    actions: @Composable RowScope.() -> Unit,
) {
    AppCard(modifier = Modifier.fillMaxWidth(), onClick = onClick) {
        Column(
            modifier = Modifier.padding(AppTheme.spacing.lg),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
        ) {
            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
            ) {
                avatar()
                Column(modifier = Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.xxs)) {
                    Text(
                        text = title,
                        style = AppTheme.typography.labelMd,
                        color = AppTheme.colors.onSurface,
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis,
                    )
                    Row(
                        horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs),
                        verticalAlignment = Alignment.CenterVertically,
                    ) {
                        kicker()
                        Text(
                            text = meta,
                            style = AppTheme.typography.labelSm,
                            color = AppTheme.colors.onSurfaceVariant,
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis,
                        )
                    }
                }
            }
            if (body.isNotBlank()) {
                Text(
                    text = body,
                    style = AppTheme.typography.bodyMd,
                    color = AppTheme.colors.onSurface,
                    maxLines = 3,
                    overflow = TextOverflow.Ellipsis,
                )
            }
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .aspectRatio(POST_PHOTO_ASPECT)
                    .clip(AppTheme.shapes.md),
            ) {
                BusinessCover(imageUrl = coverUrl, contentDescription = coverContentDescription, iconName = coverIcon)
                if (coverBadge != null) {
                    AccentBadge(
                        label = coverBadge,
                        modifier = Modifier.align(Alignment.TopEnd).padding(AppTheme.spacing.sm),
                    )
                }
            }
            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
                modifier = Modifier.fillMaxWidth(),
                content = actions,
            )
        }
    }
}

/** Round icon avatar for cards that have no photo identity (events). */
@Composable
private fun IconAvatar(iconName: String) {
    Box(
        modifier = Modifier
            .size(AppTheme.sizes.avatarSm)
            .clip(AppTheme.shapes.pill)
            .background(AppTheme.colors.categoryChip),
        contentAlignment = Alignment.Center,
    ) {
        AppIcon(name = iconName, size = AppTheme.sizes.iconSm, tint = AppTheme.colors.primary)
    }
}

/** Round logo avatar for a business (logo, else cover, else the storefront emblem). */
@Composable
private fun BusinessAvatar(business: Business?, contentDescription: String, size: Dp = AppTheme.sizes.avatarSm) {
    Box(modifier = Modifier.size(size).clip(AppTheme.shapes.pill)) {
        BusinessCover(
            imageUrl = business?.logoUrl ?: business?.coverUrl,
            contentDescription = contentDescription,
        )
    }
}

@Composable
private fun EventFeedCard(event: Event, goingCount: Int, onClick: () -> Unit) {
    val lang = AppTheme.language
    val title = event.title.resolve(lang)
    val venue = listOf(event.venue.name, lang.cityLabel(event.venue.city)).filter { it.isNotBlank() }.joinToString(", ")
    CommunityCard(
        title = title,
        meta = listOf(eventDateLabel(event.startsAtMillis), venue).filter { it.isNotBlank() }.joinToString(" · "),
        body = event.description.resolve(lang),
        coverUrl = event.coverUrl,
        coverIcon = "event",
        coverContentDescription = stringResource(Res.string.feed_card_image_a11y, title),
        onClick = onClick,
        avatar = { IconAvatar("event") },
        kicker = {
            IconBadge(
                label = stringResource(Res.string.feed_kicker_event),
                iconName = "event",
                containerColor = AppTheme.colors.secondaryContainer,
                contentColor = AppTheme.colors.onSecondaryContainer,
            )
        },
    ) {
        if (goingCount > 0) {
            AppIcon(name = "group", size = AppTheme.sizes.iconSm, tint = AppTheme.colors.onSurfaceVariant)
            Text(
                text = stringResource(Res.string.feed_event_going, lang.formatCount(goingCount)),
                style = AppTheme.typography.labelSm,
                color = AppTheme.colors.onSurfaceVariant,
            )
        }
        Spacer(Modifier.weight(1f))
        AppButton(
            text = stringResource(Res.string.feed_event_details),
            onClick = onClick,
            variant = AppButtonVariant.Text,
            trailingIcon = "chevron_right",
        )
    }
}

@Composable
private fun DealFeedCard(deal: Deal, business: Business?, onClick: () -> Unit) {
    val lang = AppTheme.language
    val headline = deal.title.resolve(lang)
    CommunityCard(
        title = deal.businessName,
        meta = dealEndsLabel(deal.endsAtMillis),
        body = listOf(headline, deal.details?.resolve(lang).orEmpty()).filter { it.isNotBlank() }.joinToString("\n"),
        coverUrl = business?.coverUrl ?: business?.photos?.firstOrNull(),
        coverIcon = "sell",
        coverBadge = stringResource(Res.string.feed_deal_badge),
        coverContentDescription = stringResource(Res.string.feed_card_image_a11y, deal.businessName),
        onClick = onClick,
        avatar = { BusinessAvatar(business, deal.businessName) },
        kicker = {
            IconBadge(
                label = stringResource(Res.string.feed_kicker_deal),
                iconName = "sell",
                containerColor = AppTheme.colors.secondaryContainer,
                contentColor = AppTheme.colors.onSecondaryContainer,
            )
        },
    ) {
        Spacer(Modifier.weight(1f))
        AppButton(
            text = stringResource(Res.string.feed_deal_view),
            onClick = onClick,
            variant = AppButtonVariant.Text,
            trailingIcon = "chevron_right",
        )
    }
}

@Composable
private fun NewBusinessFeedCard(business: Business, following: Boolean, onClick: () -> Unit, onFollow: () -> Unit) {
    val lang = AppTheme.language
    val name = business.nameLocalized?.resolve(lang)?.takeIf { it.isNotBlank() } ?: business.name
    CommunityCard(
        title = name,
        meta = stringResource(Res.string.feed_new_in_city, AppTheme.language.cityLabel(business.address.city)),
        body = business.serviceTitle?.resolve(lang)?.takeIf { it.isNotBlank() } ?: business.description.resolve(lang),
        coverUrl = business.coverUrl ?: business.photos.firstOrNull(),
        coverContentDescription = stringResource(Res.string.feed_card_image_a11y, name),
        onClick = onClick,
        avatar = { BusinessAvatar(business, name) },
        kicker = {
            IconBadge(
                label = stringResource(Res.string.feed_kicker_new),
                iconName = "new_releases",
                containerColor = AppTheme.colors.categoryChip,
                contentColor = AppTheme.colors.primary,
            )
        },
    ) {
        FollowButton(following = following, onFollow = onFollow)
        Spacer(Modifier.weight(1f))
        AppButton(
            text = stringResource(Res.string.feed_new_view),
            onClick = onClick,
            variant = AppButtonVariant.Text,
            trailingIcon = "chevron_right",
        )
    }
}

/** Stitch c8b1f8fb: outlined "Follow" flips to a filled "Following" pill. */
@Composable
private fun FollowButton(following: Boolean, onFollow: () -> Unit) {
    AppButton(
        text = stringResource(if (following) Res.string.feed_following else Res.string.feed_follow),
        onClick = onFollow,
        variant = if (following) AppButtonVariant.Primary else AppButtonVariant.Secondary,
        leadingIcon = if (following) "check" else null,
    )
}

/** "Trending near you" row: flame tile, event title, going count + date. */
@Composable
private fun TrendingRow(event: Event, goingCount: Int, onClick: () -> Unit) {
    val lang = AppTheme.language
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .clickable(onClick = onClick)
            .padding(horizontal = AppTheme.spacing.lg, vertical = AppTheme.spacing.sm),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
    ) {
        Box(
            modifier = Modifier
                .size(AppTheme.sizes.iconCircle)
                .clip(AppTheme.shapes.pill)
                .background(AppTheme.colors.secondaryContainer),
            contentAlignment = Alignment.Center,
        ) {
            AppIcon(name = "local_fire_department", size = AppTheme.sizes.iconMd, tint = AppTheme.colors.onSecondaryContainer)
        }
        Column(modifier = Modifier.weight(1f)) {
            Text(
                text = event.title.resolve(lang),
                style = AppTheme.typography.labelMd,
                color = AppTheme.colors.onSurface,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis,
            )
            Text(
                text = listOfNotNull(
                    if (goingCount > 0) stringResource(Res.string.feed_event_going, lang.formatCount(goingCount)) else null,
                    eventDateLabel(event.startsAtMillis),
                ).joinToString(" · "),
                style = AppTheme.typography.bodySm,
                color = AppTheme.colors.onSurfaceVariant,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis,
            )
        }
        AppIcon(name = "chevron_right", size = AppTheme.sizes.iconMd, tint = AppTheme.colors.onSurfaceVariant)
    }
}

/** "Suggested for you" row: logo, name + city, Follow. */
@Composable
private fun SuggestedRow(business: Business, following: Boolean, onClick: () -> Unit, onFollow: () -> Unit) {
    val lang = AppTheme.language
    val name = business.nameLocalized?.resolve(lang)?.takeIf { it.isNotBlank() } ?: business.name
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .clickable(onClick = onClick)
            .padding(horizontal = AppTheme.spacing.lg, vertical = AppTheme.spacing.sm),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
    ) {
        BusinessAvatar(business, name, size = AppTheme.sizes.iconCircle)
        Column(modifier = Modifier.weight(1f)) {
            Text(
                text = name,
                style = AppTheme.typography.labelMd,
                color = AppTheme.colors.onSurface,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis,
            )
            Text(
                text = AppTheme.language.cityLabel(business.address.city),
                style = AppTheme.typography.bodySm,
                color = AppTheme.colors.onSurfaceVariant,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis,
            )
        }
        FollowButton(following = following, onFollow = onFollow)
    }
}

/** "Ends today" / "Ends in N days" for an offer's expiry. */
@Composable
private fun dealEndsLabel(endsAtMillis: Long): String {
    val remaining = endsAtMillis - Clock.System.now().toEpochMilliseconds()
    val days = (remaining + DAY_MILLIS - 1) / DAY_MILLIS
    return if (days <= 1) stringResource(Res.string.feed_deal_ends_today)
    else stringResource(Res.string.feed_deal_ends_days, AppTheme.language.formatCount(days))
}

/** "SEP 24 • 8:00 PM" in the device zone, month names + AM/PM from resources (mirrors Home). */
@Composable
private fun eventDateLabel(epochMillis: Long): String {
    val value = kotlin.time.Instant.fromEpochMilliseconds(epochMillis)
        .toLocalDateTime(TimeZone.currentSystemDefault())
    val hour12 = when {
        value.hour == 0 -> 12
        value.hour > 12 -> value.hour - 12
        else -> value.hour
    }
    val months = stringArrayResource(Res.array.feed_months)
    // Persian digits in Farsi: resource args always render Western digits (see NumberFormatting).
    return AppTheme.language.localizeDigits(
        stringResource(
            Res.string.feed_event_date_format,
            months.getOrNull(value.month.ordinal) ?: "",
            value.day,
            hour12,
            value.minute.toString().padStart(2, '0'),
            stringResource(if (value.hour < 12) Res.string.feed_event_am else Res.string.feed_event_pm),
        ),
    )
}

private const val DAY_MILLIS = 24L * 60 * 60 * 1_000

/** Post photo aspect (Stitch c8b1f8fb card image ≈ 16:9). */
private const val POST_PHOTO_ASPECT = 16f / 9f

/**
 * "2 h ago"-style label for a post's [millis] timestamp, bucketed to the largest sensible unit
 * (localized via string resources). Clock skew (future timestamps) clamps to "just now".
 */
@Composable
private fun relativeTimeLabel(millis: Long): String {
    val minutes = ((Clock.System.now().toEpochMilliseconds() - millis) / 60_000L).coerceAtLeast(0)
    val lang = AppTheme.language
    return when {
        minutes < 1 -> stringResource(Res.string.feed_time_just_now)
        minutes < 60 -> stringResource(Res.string.feed_time_minutes_ago, lang.formatCount(minutes))
        minutes < 60 * 24 -> stringResource(Res.string.feed_time_hours_ago, lang.formatCount(minutes / 60))
        minutes < 60 * 24 * 7 -> stringResource(Res.string.feed_time_days_ago, lang.formatCount(minutes / (60 * 24)))
        else -> stringResource(Res.string.feed_time_weeks_ago, lang.formatCount(minutes / (60 * 24 * 7)))
    }
}

@Composable
private fun Composer(
    posting: Boolean,
    failed: Boolean,
    signInRequired: Boolean,
    photoAttached: Boolean,
    onAttachPhoto: () -> Unit,
    onRemovePhoto: () -> Unit,
    onPublish: (PostType, String) -> Unit,
    askRequested: Boolean = false,
    onAskConsumed: () -> Unit = {},
) {
    var text by remember { mutableStateOf("") }
    var type by remember { mutableStateOf(PostType.General) }
    // Collapsed by default — a fully expanded composer ate ~40% of the viewport before the first
    // post. Reading is the feed's primary job; composing expands on intent (tap) and stays open
    // while a draft (text/photo) or an in-flight/failed publish needs attention.
    var composing by remember { mutableStateOf(false) }
    // Clear the draft ONLY after a publish actually lands. A failed publish (network, rules) or a
    // guest sign-in gate must keep the user's text so they can retry — watch `posting` fall
    // true→false with no error surfaced in the same state emission = success.
    var wasPosting by remember { mutableStateOf(false) }
    LaunchedEffect(posting) {
        if (wasPosting && !posting && !failed && !signInRequired) {
            text = ""
            type = PostType.General
            composing = false
        }
        wasPosting = posting
    }
    // "Ask the mahaleh" (global Post sheet / empty search results): open ready-to-ask.
    LaunchedEffect(askRequested) {
        if (askRequested) {
            composing = true
            type = PostType.Question
            onAskConsumed()
        }
    }
    val expanded = composing || text.isNotBlank() || photoAttached || posting || failed
    if (!expanded) {
        AppCard(modifier = Modifier.fillMaxWidth(), onClick = { composing = true }) {
            Row(
                modifier = Modifier.padding(AppTheme.spacing.lg),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
            ) {
                AppIcon(name = "edit", tint = AppTheme.colors.onSurfaceVariant)
                Text(
                    text = stringResource(Res.string.feed_composer_placeholder),
                    style = AppTheme.typography.bodyMd,
                    color = AppTheme.colors.onSurfaceVariant,
                )
            }
        }
        return
    }
    AppCard(modifier = Modifier.fillMaxWidth()) {
        Column(
            modifier = Modifier.padding(AppTheme.spacing.lg),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
        ) {
            AppTextField(
                value = text,
                onValueChange = { text = it },
                placeholder = stringResource(Res.string.feed_composer_placeholder),
                modifier = Modifier.fillMaxWidth(),
            )
            // Type chips scroll like the filter row — three localized labels plus more later won't
            // fit a compact width, and squeezing them corrupts chip text.
            Row(
                modifier = Modifier.horizontalScroll(rememberScrollState()),
                horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
            ) {
                PostType.entries.forEach { candidate ->
                    AppChip(
                        label = stringResource(candidate.label()),
                        selected = type == candidate,
                        onClick = { type = candidate },
                    )
                }
            }
            if (photoAttached) {
                AppChip(
                    label = stringResource(Res.string.feed_composer_photo_attached),
                    selected = true,
                    leadingIcon = "close",
                    onClick = onRemovePhoto,
                )
            } else {
                AppIconButton(
                    iconName = "add_photo_alternate",
                    contentDescription = stringResource(Res.string.feed_composer_add_photo),
                    onClick = onAttachPhoto,
                )
            }
            if (failed) {
                Text(
                    text = stringResource(Res.string.feed_post_failed),
                    style = AppTheme.typography.bodySm,
                    color = AppTheme.colors.onErrorContainer,
                )
            }
            AppButton(
                text = stringResource(Res.string.feed_composer_publish),
                onClick = { onPublish(type, text) },
                modifier = Modifier.fillMaxWidth(),
                enabled = (text.isNotBlank() || photoAttached) && !posting,
                loading = posting,
                trailingIcon = "send",
            )
        }
    }
}

@Composable
private fun PostCard(
    post: Post,
    isMine: Boolean,
    liked: Boolean,
    saved: Boolean,
    onToggleLike: () -> Unit,
    onToggleSave: () -> Unit,
    onReport: () -> Unit,
    onOpenComments: () -> Unit,
    onDelete: () -> Unit,
    onEdit: () -> Unit,
    onBlock: () -> Unit,
    onShare: () -> Unit,
) {
    AppCard(modifier = Modifier.fillMaxWidth()) {
        Column(
            modifier = Modifier.padding(AppTheme.spacing.lg),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
        ) {
            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
            ) {
                PersonAvatar(
                    id = post.authorUid,
                    name = post.authorName,
                    size = AppTheme.sizes.avatarSm,
                    textStyle = AppTheme.typography.labelMd,
                )
                Column(modifier = Modifier.weight(1f)) {
                    Text(
                        text = post.authorName,
                        style = AppTheme.typography.labelMd,
                        color = AppTheme.colors.onSurface,
                    )
                    // Byline: muted time + a scannable per-type badge. A plain teal word made every
                    // post read identical at a glance (owner feedback vs. competitor feeds) — now
                    // Questions wear gold, Recommendations teal; General stays quiet text.
                    Row(
                        horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs),
                        verticalAlignment = Alignment.CenterVertically,
                    ) {
                        post.createdAtMillis?.let { millis ->
                            Text(
                                text = relativeTimeLabel(millis),
                                style = AppTheme.typography.labelSm,
                                color = AppTheme.colors.onSurfaceVariant,
                            )
                        }
                        when (post.type) {
                            PostType.Question -> IconBadge(
                                label = stringResource(post.type.label()),
                                iconName = "help",
                                containerColor = AppTheme.colors.secondaryContainer,
                                contentColor = AppTheme.colors.onSecondaryContainer,
                            )
                            PostType.Recommendation -> IconBadge(
                                label = stringResource(post.type.label()),
                                iconName = "thumb_up",
                                containerColor = AppTheme.colors.categoryChip,
                                contentColor = AppTheme.colors.primary,
                            )
                            PostType.General -> Text(
                                text = stringResource(post.type.label()),
                                style = AppTheme.typography.labelSm,
                                color = AppTheme.colors.onSurfaceVariant,
                            )
                        }
                    }
                }
                // Owner ask 2026-09-11: the two big flag/block buttons made every card shout.
                // Secondary actions live behind one three-dot menu; new ones become list entries.
                AppOverflowMenu(
                    contentDescription = stringResource(Res.string.feed_more_actions_a11y),
                    items = if (isMine) {
                        listOf(
                            AppMenuItem(
                                label = stringResource(Res.string.feed_edit_post_a11y),
                                iconName = "edit",
                                onClick = onEdit,
                            ),
                            AppMenuItem(
                                label = stringResource(Res.string.feed_delete_post_a11y),
                                iconName = "delete",
                                destructive = true,
                                onClick = onDelete,
                            ),
                        )
                    } else {
                        listOf(
                            AppMenuItem(
                                label = stringResource(Res.string.feed_report_action),
                                iconName = "flag",
                                onClick = onReport,
                            ),
                            AppMenuItem(
                                label = stringResource(Res.string.feed_block_user_a11y),
                                iconName = "block",
                                destructive = true,
                                onClick = onBlock,
                            ),
                        )
                    },
                )
            }
            Text(
                text = post.text,
                style = AppTheme.typography.bodyMd,
                color = AppTheme.colors.onSurface,
            )
            if (!post.photoUrl.isNullOrBlank()) {
                // Stitch c8b1f8fb: one full-width rounded photo between the text and the action row.
                Box(
                    modifier = Modifier
                        .fillMaxWidth()
                        .aspectRatio(POST_PHOTO_ASPECT)
                        .clip(AppTheme.shapes.md),
                ) {
                    BusinessCover(
                        imageUrl = post.photoUrl,
                        contentDescription = stringResource(Res.string.feed_post_photo_a11y),
                        iconName = "image",
                    )
                }
            }
            // Stitch c8b1f8fb action row: heart+count, comments+count, bookmark at the end.
            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
                modifier = Modifier.fillMaxWidth(),
            ) {
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs),
                    modifier = Modifier
                        .clip(AppTheme.shapes.sm)
                        .clickable(onClick = onToggleLike)
                        .heightIn(min = AppTheme.sizes.minTouchTarget)
                        .padding(vertical = AppTheme.spacing.xs, horizontal = AppTheme.spacing.xs),
                ) {
                    AppIcon(
                        name = "favorite",
                        size = AppTheme.sizes.iconSm,
                        filled = liked,
                        tint = if (liked) AppTheme.colors.primary else AppTheme.colors.onSurfaceVariant,
                        contentDescription = stringResource(
                            if (liked) Res.string.feed_unlike_a11y else Res.string.feed_like_a11y,
                        ),
                    )
                    Text(
                        text = AppTheme.language.formatCount(post.likeCount),
                        style = AppTheme.typography.labelSm,
                        color = if (liked) AppTheme.colors.primary else AppTheme.colors.onSurfaceVariant,
                    )
                }
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs),
                    modifier = Modifier
                        .clip(AppTheme.shapes.sm)
                        .clickable(onClick = onOpenComments)
                        .heightIn(min = AppTheme.sizes.minTouchTarget)
                        .padding(vertical = AppTheme.spacing.xs, horizontal = AppTheme.spacing.xs),
                ) {
                    AppIcon(name = "chat_bubble", size = AppTheme.sizes.iconSm, tint = AppTheme.colors.primary)
                    Text(
                        text = pluralStringResource(
                            Res.plurals.feed_comments,
                            post.commentCount,
                            AppTheme.language.formatCount(post.commentCount),
                        ),
                        style = AppTheme.typography.labelSm,
                        color = AppTheme.colors.primary,
                    )
                }
                Spacer(Modifier.weight(1f))
                AppIconButton(
                    iconName = "share",
                    contentDescription = stringResource(Res.string.feed_share_a11y),
                    onClick = onShare,
                )
                AppIconButton(
                    iconName = "bookmark",
                    filled = saved,
                    contentDescription = stringResource(
                        if (saved) Res.string.feed_unsave_a11y else Res.string.feed_save_a11y,
                    ),
                    onClick = onToggleSave,
                )
            }
        }
    }
}

/**
 * Comments thread for a post, shown as a bottom sheet from the feed card's comment row. Live comments
 * (oldest first) + a composer. Reading is public; a guest who tries to post is routed to sign-in.
 */
@Composable
private fun CommentsSheet(
    postId: String,
    onRequireSignIn: () -> Unit,
    onDismiss: () -> Unit,
    onOpenBusiness: (String) -> Unit = {},
) {
    val viewModel: CommentsViewModel = koinViewModel(parameters = { parametersOf(postId) })
    val state by viewModel.state.collectAsStateWithLifecycle()
    var text by remember { mutableStateOf("") }
    var deleteCommentId by remember { mutableStateOf<String?>(null) }
    var reportCommentId by remember { mutableStateOf<String?>(null) }
    var showBusinessPicker by remember { mutableStateOf(false) }

    LaunchedEffect(state.signInRequired) {
        if (state.signInRequired) {
            viewModel.consumeGate()
            onDismiss()
            onRequireSignIn()
        }
    }
    LaunchedEffect(state.reportStatus) {
        if (state.reportStatus == CommentReportStatus.SignInRequired) {
            reportCommentId = null
            viewModel.resetReport()
            onDismiss()
            onRequireSignIn()
        }
    }

    reportCommentId?.let { commentId ->
        ReportSheet(
            title = stringResource(Res.string.feed_comment_report_title),
            reasons = listOf(
                ReportReason(stringResource(Res.string.feed_report_reason_offensive), "offensive_content"),
                ReportReason(stringResource(Res.string.feed_report_reason_harassment), "harassment"),
                ReportReason(stringResource(Res.string.feed_report_reason_spam), "spam"),
                ReportReason(stringResource(Res.string.feed_report_reason_misinformation), "misinformation"),
            ),
            status = when (state.reportStatus) {
                CommentReportStatus.Sending -> ReportStatus.Sending
                CommentReportStatus.Sent -> ReportStatus.Sent
                CommentReportStatus.Failed -> ReportStatus.Failed
                CommentReportStatus.Idle, CommentReportStatus.SignInRequired -> ReportStatus.Idle
            },
            sentText = stringResource(Res.string.feed_comment_report_sent),
            failedText = stringResource(Res.string.feed_report_failed),
            submitText = stringResource(Res.string.feed_report_submit),
            doneText = stringResource(Res.string.feed_report_done),
            onSubmit = { reason -> viewModel.reportComment(commentId, reason) },
            onDismiss = {
                reportCommentId = null
                viewModel.resetReport()
            },
        )
    }

    if (showBusinessPicker) {
        AppBottomSheet(
            onDismissRequest = {
                showBusinessPicker = false
                viewModel.setPickerVisible(false)
            },
            title = stringResource(Res.string.feed_recommend_title),
        ) {
            Column(
                modifier = Modifier.fillMaxWidth(),
                verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
            ) {
                AppTextField(
                    value = state.pickerQuery,
                    onValueChange = viewModel::onPickerQueryChange,
                    placeholder = stringResource(Res.string.feed_recommend_search),
                    modifier = Modifier.fillMaxWidth(),
                )
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .heightIn(max = AppTheme.sizes.commentsListMaxHeight)
                        .verticalScroll(rememberScrollState()),
                    verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
                ) {
                    state.pickerResults.forEach { business ->
                        Row(
                            modifier = Modifier
                                .fillMaxWidth()
                                .clip(AppTheme.shapes.sm)
                                .clickable {
                                    viewModel.attachBusiness(business)
                                    showBusinessPicker = false
                                    viewModel.setPickerVisible(false)
                                }
                                .padding(AppTheme.spacing.sm),
                            horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
                            verticalAlignment = Alignment.CenterVertically,
                        ) {
                            AppIcon(name = "storefront", tint = AppTheme.colors.primary)
                            Column(modifier = Modifier.weight(1f)) {
                                Text(
                                    text = business.displayName(AppTheme.language),
                                    style = AppTheme.typography.bodyMd,
                                    color = AppTheme.colors.onSurface,
                                )
                                Text(
                                    text = business.serviceLine(AppTheme.language),
                                    style = AppTheme.typography.bodySm,
                                    color = AppTheme.colors.onSurfaceVariant,
                                )
                            }
                        }
                    }
                }
            }
        }
    }

    deleteCommentId?.let { commentId ->
        AppConfirmDialog(
            title = stringResource(Res.string.feed_delete_comment_title),
            message = stringResource(Res.string.feed_delete_comment_message),
            confirmLabel = stringResource(Res.string.feed_delete_confirm),
            cancelLabel = stringResource(Res.string.feed_delete_cancel),
            destructive = true,
            onConfirm = {
                viewModel.deleteComment(commentId)
                deleteCommentId = null
            },
            onDismiss = { deleteCommentId = null },
        )
    }

    AppBottomSheet(onDismissRequest = onDismiss, title = stringResource(Res.string.feed_comments_title)) {
        Column(
            modifier = Modifier.fillMaxWidth(),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
        ) {
            if (!state.loading && state.comments.isEmpty()) {
                Text(
                    text = stringResource(Res.string.feed_comment_empty),
                    style = AppTheme.typography.bodyMd,
                    color = AppTheme.colors.onSurfaceVariant,
                )
            } else {
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .heightIn(max = AppTheme.sizes.commentsListMaxHeight)
                        .verticalScroll(rememberScrollState()),
                    verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
                ) {
                    state.comments.forEach { comment ->
                        CommentRow(
                            comment = comment,
                            onDelete = { deleteCommentId = comment.id },
                            onReport = { reportCommentId = comment.id },
                            onOpenBusiness = onOpenBusiness,
                        )
                    }
                }
            }
            if (state.commentFailed) {
                Text(
                    text = stringResource(Res.string.feed_comment_failed),
                    style = AppTheme.typography.bodySm,
                    color = AppTheme.colors.onErrorContainer,
                )
            }
            if (state.deleteFailed) {
                Text(
                    text = stringResource(Res.string.feed_comment_delete_failed),
                    style = AppTheme.typography.bodySm,
                    color = AppTheme.colors.onErrorContainer,
                )
            }
            AppTextField(
                value = text,
                onValueChange = { text = it },
                placeholder = stringResource(Res.string.feed_comment_placeholder),
                modifier = Modifier.fillMaxWidth(),
            )
            // "Ask the Mahaleh" answers carry a business: attach one from the directory picker.
            val attached = state.attachedBusiness
            if (attached != null) {
                AppChip(
                    label = stringResource(Res.string.feed_recommend_attached, attached.displayName(AppTheme.language)),
                    selected = true,
                    leadingIcon = "close",
                    onClick = { viewModel.attachBusiness(null) },
                )
            } else {
                AppButton(
                    text = stringResource(Res.string.feed_recommend_business),
                    onClick = {
                        showBusinessPicker = true
                        viewModel.setPickerVisible(true)
                    },
                    variant = AppButtonVariant.Secondary,
                    leadingIcon = "storefront",
                    modifier = Modifier.fillMaxWidth(),
                )
            }
            AppButton(
                text = stringResource(Res.string.feed_comment_send),
                onClick = {
                    viewModel.submit(text)
                    text = ""
                },
                modifier = Modifier.fillMaxWidth(),
                enabled = text.isNotBlank() && !state.posting,
                loading = state.posting,
                trailingIcon = "send",
            )
        }
    }
}

@Composable
private fun CommentRow(
    comment: diana.soleil.design.iraniancanadienbazzar.core.model.Comment,
    onDelete: () -> Unit,
    onReport: () -> Unit,
    onOpenBusiness: (String) -> Unit = {},
) {
    Row(
        horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
        verticalAlignment = Alignment.Top,
    ) {
        PersonAvatar(
            id = comment.authorUid,
            name = comment.authorName,
            size = AppTheme.sizes.avatarSm,
            textStyle = AppTheme.typography.labelMd,
        )
        Column(modifier = Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.xxs)) {
            Text(
                text = comment.authorName,
                style = AppTheme.typography.labelMd,
                color = AppTheme.colors.onSurface,
            )
            Text(
                text = comment.text,
                style = AppTheme.typography.bodyMd,
                color = AppTheme.colors.onSurfaceVariant,
            )
            // "Ask the Mahaleh": the answer's recommended business, tappable through to its listing.
            val recommendedId = comment.recommendedBusinessId
            if (recommendedId != null) {
                Row(
                    modifier = Modifier
                        .clip(AppTheme.shapes.sm)
                        .background(AppTheme.colors.surfaceContainer, AppTheme.shapes.sm)
                        .clickable { onOpenBusiness(recommendedId) }
                        .padding(horizontal = AppTheme.spacing.md, vertical = AppTheme.spacing.sm),
                    horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
                    verticalAlignment = Alignment.CenterVertically,
                ) {
                    AppIcon(
                        name = "storefront",
                        size = AppTheme.sizes.iconSm,
                        tint = AppTheme.colors.primary,
                        contentDescription = stringResource(Res.string.feed_comment_recommended_a11y),
                    )
                    Text(
                        text = comment.recommendedBusinessName ?: recommendedId,
                        style = AppTheme.typography.labelMd,
                        color = AppTheme.colors.primary,
                    )
                    AppIcon(name = "chevron_right", size = AppTheme.sizes.iconSm, tint = AppTheme.colors.primary)
                }
            }
        }
        // Same quiet overflow as the post card.
        AppOverflowMenu(
            contentDescription = stringResource(Res.string.feed_more_actions_a11y),
            items = if (comment.isMine) {
                listOf(
                    AppMenuItem(
                        label = stringResource(Res.string.feed_delete_comment_a11y),
                        iconName = "delete",
                        destructive = true,
                        onClick = onDelete,
                    ),
                )
            } else {
                listOf(
                    AppMenuItem(
                        label = stringResource(Res.string.feed_comment_report_action),
                        iconName = "flag",
                        onClick = onReport,
                    ),
                )
            },
        )
    }
}

/** Edit an existing post's type + text (author-only; opened from the post card's edit action). */
@Composable
private fun EditPostSheet(
    post: Post,
    onDismiss: () -> Unit,
    onSave: (PostType, String) -> Unit,
) {
    var text by remember { mutableStateOf(post.text) }
    var type by remember { mutableStateOf(post.type) }
    AppBottomSheet(onDismissRequest = onDismiss, title = stringResource(Res.string.feed_edit_post_title)) {
        Column(
            modifier = Modifier.fillMaxWidth(),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
        ) {
            AppTextField(
                value = text,
                onValueChange = { text = it },
                placeholder = stringResource(Res.string.feed_composer_placeholder),
                modifier = Modifier.fillMaxWidth(),
                singleLine = false,
            )
            Row(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
                PostType.entries.forEach { candidate ->
                    AppChip(
                        label = stringResource(candidate.label()),
                        selected = type == candidate,
                        onClick = { type = candidate },
                    )
                }
            }
            AppButton(
                text = stringResource(Res.string.feed_edit_post_save),
                onClick = { onSave(type, text) },
                modifier = Modifier.fillMaxWidth(),
                enabled = text.isNotBlank(),
            )
        }
    }
}
